import { SpaPackageListingType } from 'shared-types/SpaPackage';

export const filterNotAvailableEntities = (
  spaDaysAll: SpaPackageListingType[],
  availableSpaDays: SpaPackageListingType[]
): SpaPackageListingType[] =>
  (spaDaysAll.length &&
    spaDaysAll
      .filter((spaDayAll) => !availableSpaDays.find((spaDay) => spaDayAll.id === spaDay.id))
      .map((day) => ({ ...day, unAvailable: true }))) ||
  [];
